import React from 'react';
import { Button } from 'antd';
import { AimOutlined, LineOutlined, SketchOutlined, FontSizeOutlined } from '@ant-design/icons';

interface SketchToolbarProps {
  drawingMode: string;
  setDrawingMode: (mode: string) => void;
  resetEntities: () => void;
}

const SketchToolbar: React.FC<SketchToolbarProps> = ({ drawingMode, setDrawingMode, resetEntities }) => {
  const handleModeChange = (mode: string) => {
    setDrawingMode(mode);
    resetEntities();
  };

  return (
    <div className="geometry-options">
      <div className="buttons">
        <Button type={drawingMode === 'point' ? 'primary' : 'default'} icon={<AimOutlined />} onClick={() => handleModeChange('point')}>
          Point
        </Button>
        <Button type={drawingMode === 'line' ? 'primary' : 'default'} icon={<LineOutlined />} onClick={() => handleModeChange('line')}>
          Line
        </Button>
        <Button type={drawingMode === 'polygon' ? 'primary' : 'default'} icon={<SketchOutlined />} onClick={() => handleModeChange('polygon')}>
          Polygon
        </Button>
        <Button type={drawingMode === 'text' ? 'primary' : 'default'} icon={<FontSizeOutlined />} onClick={() => handleModeChange('text')}>
          Text
        </Button>
      </div>
      {!drawingMode && <div>Please select a geometry type</div>}
      {drawingMode && <div>Click on the map to start drawing your {drawingMode}</div>}
    </div>
  );
};

export default SketchToolbar;
